<div *transloco="let t" class="h-dvh w-screen custom-scrollbar bg-gray-50">
    <div class="h-[70px] w-screen animated-bg flex items-center px-5">
         <div class="text-white text-[32px] font-bold">{{t('routes.rules.menu')}}</div>
    </div>
    <div style="white-space: pre-line;" class="px-5 py-10 md:px-[10vw] mx-auto h-[calc(100dvh-70px)] overflow-y-scroll">
        @for (item of [].constructor(6); track $index) {
            <div class="pt-5 font-semibold text-[24px]">{{t('rules.art'+$index)}}</div>
            <div class="text-[16px] pt-1">{{t('rules.art'+$index+'Desc')}}</div>
        }
    </div>
</div>